import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FeaturesApi } from '../../../apis/FeaturesApi/FeaturesApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';

export function useSetRoleFeatures() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ roleTypeId, featureIds }: { roleTypeId: number; featureIds: number[] }) =>
            FeaturesApi.setRoleFeatures(roleTypeId, featureIds),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.roleFeatureConfig] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.visibleFeatures] });
        },
    });
}
